import { Helpers } from '../../helpers';
import { IWellType } from '../../interfaces/iwell-type';
import { Well } from '../well';

export class WellTypeBase {
  WellTypeId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  Wells_WellType?: Array<Well> | null;

  constructor(item?: IWellType) {
    if (item) {
      this.WellTypeId = item.WellTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.Wells_WellType = Helpers.createClassArray(Well, item.Wells_WellType);

    }
  }
}